<template>
  <div ref="baseModalRef" class="search-images-container">

    <div class="modal-header">
      <h5>IMG Library</h5>
    </div>

    <div class="modal-body" v-show="!isMinimized">

      <div id="buscador" class="form">
        <div class="container-fluid">
          <div class="row">
            <div class="media-container">
              <div ref="imageContainer" class="image-container">
                <img v-if="selectedPhoto?.filename_jpg" :src="'/fserver/videos' +
                  selectedPhoto?.filename_jpg?.replace('Stills', 'stills').replace('\\', '/') ||
                  ''
                  " alt="Foto" width="auto" class="video-player" />
              </div>
            </div>


          </div>
          <div class="row">
            <div class="datos-media" :key="currentVideoDetail?.utc">
              <strong>Image Info</strong>
              <!-- Vista previa principal -->
              <div class="preview-row d-flex align-items-center" style="cursor:pointer;"
                @click="showDetails = !showDetails">
                <div style="flex:1">
                  <span>File: {{ getFilenameFromPath(photoDetail?.filename_jpg) }}</span>
                  <span style="margin-left:10px;">- UTC: {{ photoDetail?.utc }}</span>
                </div>
                <button class="btn btn-link btn-sm" @click.stop="showDetails = !showDetails"
                  :aria-expanded="showDetails">
                  <span v-if="showDetails">&#9650;</span><!-- ▲ -->
                  <span v-else>&#9660;</span><!-- ▼ -->
                </button>
              </div>

              <!-- Detalles expandibles -->
              <transition name="fade">
                <div v-if="showDetails">
                  <div class="row">
                    <div class="col-3">
                      <label>Type</label>
                    </div>
                    <div class="col-9">
                      <label>{{ getFileSigla(photoDetail?.filename_jpg) }}</label>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-3">
                      <label>Vertices</label>
                    </div>
                    <div class="col-9">
                      <label> {{ getGeoJsonCoordinates(photoDetail?.cam_polygon) }}</label>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-3">
                      <label>Image Center</label>
                    </div>
                    <div class="col-9">
                      <label>{{ getGeoJsonCoordinates(photoDetail?.center_location) }}</label>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <div class="row mb-2"><button class="btn btn-secondary btn-sm btn-vlc-selected" @click="abrirEnVLC">Open in
                Player</button></div>
          </div>



          <div class="row mt-2 mb-2">
            <div class="col-6 col-6-small">

              <h5>Filters</h5>
              <div class="row">
                <div class="">
                  <select class="form-select form-select-sm mb-1" v-model="filters.data" aria-label=""
                    @change="callApi">
                    <option selected value="">Video</option>
                    <option value="PRIMARY">Primary</option>
                    <option value="ALTERNATE">Alternate</option>
                  </select>

                  <div class="filter-group">
                    <!-- FECHA DESDE -->
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" value="" id="showStartDate"
                        v-model="filters.showStartDate" @change="callApi" />
                      <label class="form-check-label" for="flexCheckDefault"> From </label>
                    </div>
                    <div v-if="filters.showStartDate">
                      <input type="date" v-model="filters.start_date" @change="callApi" class="form-control" />
                    </div>
                  </div>

                  <div class="filter-group">
                    <!-- FECHA HASTA -->
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" value="" id="showEndDate"
                        v-model="filters.showEndDate" @change="callApi" />
                      <label class="form-check-label" for="flexCheckDefault"> To </label>
                    </div>
                    <div v-if="filters.showEndDate">
                      <input type="date" v-model="filters.end_date" @change="callApi" class="form-control" />
                    </div>
                  </div>

                  <div class="filter-group">
                    <!-- TIPO -->
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" value="" id="type" v-model="filters.showTipo"
                        @change="callApi" />
                      <label class="form-check-label" for="flexCheckDefault"> Type </label>
                    </div>
                    <div :hidden="!filters.showTipo">
                      <select v-model="filters.tipo" @change="callApi" class="form-control">
                        <option class="form-select form-select-sm" value="HD-EO">HD-EO</option>
                        <option class="form-select form-select-sm" value="MWIR">MWIR</option>
                      </select>
                    </div>
                  </div>

                  <div class="filter-group">
                    <!-- ZONA -->
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" value="" id="showZona" v-model="filters.showZona"
                        @change="callApi" />
                      <label class="form-check-label" for="flexCheckDefault"> Zone </label>
                    </div>
                    <div :hidden="!filters.showZona" class="form-text">
                      <label class="form-text-label" for="flexTextDefault"> Lat </label>
                      <input class="form-number-input" type="number" id="init_number" v-model="filters.lat_zona"
                        @change="callApi" />
                      <label class="form-text-label" for="flexTextDefault"> Lon </label>
                      <input class="form-number-input" type="number" id="end_number" v-model="filters.lon_zona"
                        @change="callApi" />

                      <label class="form-text-label" for="flexTextDefault"> Radius </label>
                      <input class="form-number-input" type="number" id="end_number" v-model="filters.rad_zona"
                        @change="callApi" />
                    </div>
                  </div>

                  <div class="filter-group">
                    <!-- PREDIO -->
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" value="" id="showPredios"
                        v-model="filters.showPredio" @change="callApi" />
                      <label class="form-check-label" for="flexCheckDefault"> Predio </label>
                    </div>
                    <div :hidden="!filters.showPredio" v-if="prediosList">
                      <select class="form-select form-select-sm" aria-label="Default select example"
                        v-model="filters.predio_name" @change="callApi">
                        <option v-for="predio in prediosList" v-bind:key="predio.name">
                          {{ predio.name }}
                        </option>
                      </select>
                      <label class="form-text-label" for="flexTextDefault"> Radius </label>
                      <input class="form-number-input" type="number" v-model="filters.predio_rad" @change="callApi" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-5 col-5-small">
              <div class="text-center">
                <label>Imagenes Filtradas <span>({{ cantidadPhotos }})</span></label>
              </div>


              <div class="video-list">
                <div v-for="photo in photoFiles" :key="photo.photo_id" class="image-item"
                  :class="{ selected: selectedPhoto?.photo_id === photo.photo_id }" @click="changePhoto(photo)">
                  <div class="image-item-content">
                    <!-- Nombre del archivo (mismo que mostraba el select) -->
                    <div class="image-filename">
                      {{ getImageFilename(photo.filename_jpg) }}
                    </div>
                  </div>
                </div>

                <!-- Mensaje cuando no hay imágenes -->
                <div v-if="photoFiles.length === 0" class="no-images">
                  <i class="bi bi-image"></i>
                  <p>No se encontraron imágenes</p>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script setup lang="ts">
import { ref, reactive, onMounted } from 'vue'
import 'video.js/dist/video-js.css'
import { useBrowserDetect } from 'vue3-detect-browser'
import type { PhotoFilesFilter, PhotoFile, PhotoDetailEntry } from '../types'
import API from '../services'
import { AxiosError } from 'axios'
import { useGlobalStore } from '@/stores/global'
import { useServicesStore } from '@/stores/services'
import { storeToRefs } from 'pinia'

const global = useGlobalStore()
const { loadedPhotos, selectedPhoto, currentVideoId, currentVideoDetail, videoDetails, selectedVideoMarker } = storeToRefs(global)

const serv = useServicesStore()
const { prediosList, events, photoFiles, cantidadPhotos } = storeToRefs(serv)

const { isSafari } = useBrowserDetect()

const imageContainer = ref<HTMLElement | null>(null)
const baseModalRef = ref()
const modal = ref<HTMLElement | null>(null)
const photoDetail = ref<PhotoDetailEntry | null>(null)


const isMinimized = ref(false)
const showDetails = ref(false)

const filters = reactive({
  showStartDate: false,
  showEndDate: false,
  start_date: '',
  end_date: '',
  data: '',
  showTipo: false,
  tipo: '',
  inicio_objetivo: 0,
  final_objetivo: 0,
  showZona: false,
  lat_zona: 0,
  lon_zona: 0,
  rad_zona: 10,
  showPredio: false,
  predio_name: '',
  predio_rad: 10,
  showEvent: false,
  event: 0,
  oscuras: false
})

const video = reactive({
  fileName: ''
})

const props = defineProps({
  modalId: { type: String, required: true },
  title: { type: String, default: 'Modal' },
  isVisible: { type: Boolean, required: true }
})

const emit = defineEmits<{
  (event: 'closed'): void
  (event: 'imageSelected', coordenadas: number[]): void
  (event: 'minimize', modalId: string): void
  (event: 'restore', modalId: string): void
  (event: 'videoSelected', coordinates: number[]): void
}>()

const videoOptions = reactive({
  autoplay: true,
  controls: true,
  fluid: false,
  preload: 'auto',
  html5: {
    vhs: {
      overrideNative: !isSafari,
      bandwidth: 5039
    },
    nativeAudioTracks: false,
    nativeVideoTracks: false
  },
  sources: [
    {
      src: '/videos/2024-02-28_19-21-13/2024-02-28_19-21-13_PRIMARY.m3u8',
      type: 'application/x-mpegURL'
    }
  ],
  width: 500,
  height: 300
})

defineExpose({
  restoreModal: () => {
    if (baseModalRef.value) {
      baseModalRef.value.restoreModal()
    }
  },
  isMinimized,
  restoreModalFunc
})

// Función para obtener solo el nombre del archivo
function getFilenameFromPath(fullPath: string | null | undefined): string | null {
  if (!fullPath || fullPath.trim() === '') return null
  const parts = fullPath.split('\\')
  const filename = parts[parts.length - 1] || ''
  return filename.trim() === '' ? null : filename
}

// Función para extraer la sigla (texto entre el último "_" y la extensión)
function getFileSigla(fullPath: string | null | undefined): string | null {
  if (!fullPath || fullPath.trim() === '') return null

  const filename = getFilenameFromPath(fullPath)
  if (!filename) return null

  // Ejemplo: "2024-02-28_21-16-33-827_HD-EO.jpg"

  // Separar por puntos para quitar la extensión
  const nameWithoutExtension = filename.split('.')[0]
  if (!nameWithoutExtension) return null

  // Separar por "_" y tomar el último elemento
  const parts = nameWithoutExtension.split('_')
  const sigla = parts[parts.length - 1] || ''
  return sigla.trim() === '' ? null : sigla
}

// Función para obtener el nombre completo sin la ruta
function getFullFilename(fullPath: string | null | undefined): string | null {
  if (!fullPath || fullPath.trim() === '') return null
  const parts = fullPath.split('\\')
  const filename = parts[parts.length - 1] || ''
  return filename.trim() === '' ? null : filename
}

// Función combinada que retorna tanto el filename como la sigla
function parseFilename(fullPath: string | null | undefined): {
  filename: string | null
  sigla: string | null
  fullFilename: string | null
} {
  if (!fullPath || fullPath.trim() === '') {
    return { filename: null, sigla: null, fullFilename: null }
  }

  const fullFilename = getFilenameFromPath(fullPath)
  if (!fullFilename) {
    return { filename: null, sigla: null, fullFilename: null }
  }

  const nameWithoutExtension = fullFilename.split('.')[0]
  if (!nameWithoutExtension) {
    return { filename: null, sigla: null, fullFilename: fullFilename }
  }

  const parts = nameWithoutExtension.split('_')
  const sigla = parts[parts.length - 1] || ''

  return {
    filename: nameWithoutExtension.trim() === '' ? null : nameWithoutExtension,
    sigla: sigla.trim() === '' ? null : sigla,
    fullFilename: fullFilename
  }
}

// También actualiza getImageFilename para consistencia
function getImageFilename(filename: string | null | undefined): string | null {
  if (!filename || filename.trim() === '') return null

  // Mismo comportamiento que el select: photo.filename_jpg.split('\\')[3]
  const parts = filename.split('\\')
  const result = parts[3] || parts[parts.length - 1] || ''
  return result.trim() === '' ? null : result
}
function getGeoJsonCoordinates(geoJson: string | null | undefined): string {
  if (!geoJson) return 'N/A'

  try {
    const location = JSON.parse(geoJson)

    if (location.type === 'Point' && location.coordinates && Array.isArray(location.coordinates)) {
      // Para Point: retorna "lat lon"
      const [longitude, latitude] = location.coordinates
      return `${latitude} ${longitude}`
    }

    if (
      location.type === 'Polygon' &&
      location.coordinates &&
      Array.isArray(location.coordinates)
    ) {
      // Para Polygon: retorna "lat1 lon1,lat2 lon2,lat3 lon3,..."
      const coordinates = location.coordinates[0] // Primer anillo del polígono

      if (Array.isArray(coordinates)) {
        const formattedCoords = coordinates
          .map(([lon, lat]: [number, number]) => `${lat} ${lon}`)
          .join(', ')

        return formattedCoords
      }
    }

    return 'Formato no válido'
  } catch (error) {
    console.error('Error parseando coordenadas:', error)
    return 'Error parseando'
  }
}
async function fetchPhotoDetail(photoId: number) {
  try {
    console.log('🔍 Obteniendo detalles de la foto ID:', photoId)

    const { status, data } = await API.getPhotoDetail(photoId)

    if (status === 200 && data.Entries.Entry.length > 0) {
      photoDetail.value = data.Entries.Entry[0]
      console.log('✅ Detalles obtenidos:', photoDetail.value)

      // Opcional: parsear las ubicaciones JSON
      if (photoDetail.value) {
        const parsedLocations = parsePhotoLocations(photoDetail.value)
        console.log('📍 Ubicaciones parseadas:', parsedLocations)
      }

      return photoDetail.value
    } else {
      console.error('❌ No se encontraron detalles para la foto')
      photoDetail.value = null
      return null
    }
  } catch (error) {
    console.error('❌ Error obteniendo detalles de la foto:', error)
    photoDetail.value = null
    return null
  }
}
// Función auxiliar para parsear las ubicaciones GeoJSON
function parsePhotoLocations(detail: PhotoDetailEntry) {
  try {
    return {
      camera: JSON.parse(detail.camera_location),
      center: JSON.parse(detail.center_location),
      min: JSON.parse(detail.min_location),
      max: JSON.parse(detail.max_location),
      polygon: JSON.parse(detail.cam_polygon)
    }
  } catch (error) {
    console.error('Error parseando ubicaciones:', error)
    return null
  }
}
function changePhoto(photo: PhotoFile) {
  selectedPhoto.value = photo
  if (photo.photo_id) {
    fetchPhotoDetail(photo.photo_id)
  }
  emit('imageSelected', [
    Number(selectedPhoto.value?.lon || 0),
    Number(selectedPhoto.value?.lat || 0)
  ])
}

function toggleFullScreen() {
  if (!document.fullscreenElement) {
    imageContainer.value?.requestFullscreen().catch((err: Error) => {
      alert(`Error al intentar entrar en modo de pantalla completa: ${err.message} (${err.name})`)
    })
  } else {
    document.exitFullscreen()
  }
}

function restoreModalFunc() {
  console.log('Restaurando modal:', props.modalId)
  isMinimized.value = false
  emit('restore', props.modalId)
}



function formatUtc(str?: string): string {
  if (!str) return ''
  const match = str.match(/^(\d{4}-\d{2}-\d{2})_(\d{2})-(\d{2})-(\d{2})-(\d{3})$/)
  if (!match) return str
  const [, date, hh, mm, ss, ms] = match
  return `${date} ${hh}:${mm}:${ss}.${ms}`
}

async function abrirEnVLC() {
  const url = 'https://apialerce.terminus.cl/fserver/videos' + selectedPhoto.value?.filename_jpg?.replace('Stills', 'stills').replace(/\\/g, '/');
  console.log('Llamando a Player con URL: ' + url);
  const start_time =  0;
  const payload = {
    url,
    fullscreen: false,
    volume: 100,
    start_time: start_time
  };
  try {
    const response = await fetch('http://localhost:8001/play', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
    if (response.status === 200) {
      window.close();
    }
  } catch (error) {
    console.error('Error al comunicar con Player:', error);
    alert('No se pudo comunicar con la API local de Player.');
  }
}
onMounted(() => {
  callApi()
})
async function callApi() {
  loadedPhotos.value = false
  const filtros: PhotoFilesFilter = {
    start_date: filters.showStartDate ? filters.start_date.replace(/-/g, '') : '',
    end_date: filters.showEndDate ? filters.end_date.replace(/-/g, '') : '',
    tipo: filters.showTipo ? filters.tipo : '',
    lat_zona: filters.showZona ? filters.lat_zona : 0,
    lon_zona: filters.showZona ? filters.lon_zona : 0,
    rad_zona: filters.showZona ? filters.rad_zona : 0,
    predio_name: filters.showPredio ? filters.predio_name : '',
    predio_rad: filters.showPredio ? filters.predio_rad : 0,
    event: filters.showEvent ? filters.event : 0,
    brightness: filters.oscuras ? 0 : 80
  }
  await serv.dispatchListPhotos(filtros)
  loadedPhotos.value = true
}




</script>
<style lang="css" scoped>
.search-images-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  color: white;
}

/* clase global para los close de los modales */
.form {
  background-color: transparent;
}

span.closeCampos.close {
  height: 25px;
  line-height: 9px;
  background-color: #6c757d;
  padding: 6px;
  border-radius: 5px;
}

/* alto de tabla contenedor */

.table-wrapper {
  overflow-y: scroll;
  height: 80vh;
}

.my-3 {
  min-height: 1px;
}

.video-list-item {
  padding: 6px 12px;
  cursor: pointer;
  font-size: 13px;
}

.video-list-item.selected {
  background: #ffe082;
  color: black;
  font-weight: bold;
}

.video-list-item:hover {
  background: #f5f5f5;
}


.btn-vlc-selected {
  font-size: 11px !important;
  margin-right: 12px;
  width: 80%;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  max-height: 0;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
  max-height: 500px;
}

.modal-body {
  padding: 10px;
  overflow-y: scroll;
  height: calc(100vh - 75px);
}

.row .datos-media {
  max-width: none;
  margin-top: auto;
  overflow: hidden;
  text-wrap: wrap;
  margin-bottom: 10px;
}

.search-images-container .modal-header {
  height: auto;
}

.btn-link {
  color: white;
  text-decoration: none;
  margin-right: 0%;
}

.col-5 .video-list {
  max-height: none;
  height: 390px;
  overflow-y: auto;
}

.row .col-5 {
  max-width: none;
}

.media-container {
  height: 40vh;
  overflow: hidden;
  min-width: 0;
  min-height: 0;
}

video {
  height: 400px;
}

.video-player {
  height: 400px;
}



.form-text .form-number-input {
  width: 80px;
  margin-left: 10px;
}

.row.mt-2.mb-2 {
  padding-bottom: 10px;
}


.img-title {
  font-size: 14px;
  text-align: left;
  font-weight: normal;
}

.image-container {
  height: 100%;
  display: flex;
  justify-content: center;
}

.image-filename {
  flex: 1;
  font-size: 12px;
  font-weight: 500;
  color: white;
  word-break: break-word;
  line-height: 1.3;
  min-width: 0;
}

.selection-indicator {
  color: #5ba1df;
  font-size: 16px;
  margin-left: 8px;
}

.image-item {
  margin-bottom: 6px;
  border-radius: 6px;
  transition: all 0.2s ease;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid transparent;
}


.image-item:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
  transform: translateY(-1px);
}

.image-item.selected {
  background: rgba(91, 161, 223, 0.3);
  border-color: #5ba1df;
  box-shadow: 0 2px 8px rgba(91, 161, 223, 0.3);
}
</style>
